/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getListMutes.defs'
export { main as default } from './getListMutes.defs'
